import sal from 'sal.js'

export function loading(){
  setTimeout(function(){
    $('body').addClass('loaded')
    setTimeout(function(){
      sal({
        selector: 'footer, main > section',
        animateClassName: 'scroll-show',
        threshold: 0.01,
        once: true,
        rootMargin: "-20% 50%"
      });
    }, 300)
  }, 600);
}
